import { switchNotAllowedComponent } from './switchNotAllowed.component';
import { stateResolver } from '../../app.state';

export const switchNotAllowedStateName = 'app.switchNotAllowed';

export const switchNotAllowedState = ($stateProvider) => {
  'ngInject';

  $stateProvider.state({
    url: '/switchNotAllowed',
    name: switchNotAllowedStateName,
    component: switchNotAllowedComponent.name,
    resolve: { stateResolver: stateResolver(switchNotAllowedStateName) },
  });
};



// WEBPACK FOOTER //
// ./src/app/components/switchNotAllowed/switchNotAllowed.state.js